import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-chrome';

@Component({
    selector: 'app-codeeditor',
    templateUrl: './codeeditor.component.html',
    styleUrls: ['./codeeditor.component.scss'],
    standalone: false
})
export class CodeeditorComponent implements AfterViewInit, OnChanges, OnDestroy {

  @Input()
  public Mode: any = 'html';

  @Input()
  public Model: any = '';

  @Output()
  public ModelChange = new EventEmitter<string>();

  public StyleEditorOptions: any = { maxLines: 8000, printMargin: false };

  @ViewChild('aceeditor') editor!: ElementRef<HTMLDivElement>;

  private aceEditor?: ace.Ace.Editor;
  private changeTimer?: ReturnType<typeof setTimeout>;

  constructor() { }

  ngAfterViewInit(): void {
    this.aceEditor = ace.edit(this.editor.nativeElement);
    this.aceEditor.setTheme('ace/theme/chrome');
    this.aceEditor.setOptions(this.StyleEditorOptions);
    this.aceEditor.session.setUseWorker(false);
    this.setMode();
    this.setEditorValue(this.Model);
    this.aceEditor.session.on('change', () => this.queueModelChange());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Mode'] && this.aceEditor) {
      this.setMode();
    }

    if (changes['Model'] && this.aceEditor) {
      this.setEditorValue(this.Model);
    }
  }

  ngOnDestroy(): void {
    if (this.changeTimer) {
      clearTimeout(this.changeTimer);
    }

    this.aceEditor?.destroy();
  }

  private setMode(): void {
    const mode = `${this.Mode ?? 'html'}`.toLowerCase();
    this.aceEditor?.session.setMode(`ace/mode/${mode}`);
  }

  private setEditorValue(value: any): void {
    const editorValue = value ?? '';

    if (this.aceEditor && this.aceEditor.getValue() !== editorValue) {
      this.aceEditor.setValue(editorValue, -1);
    }
  }

  private queueModelChange(): void {
    if (this.changeTimer) {
      clearTimeout(this.changeTimer);
    }

    this.changeTimer = setTimeout(() => {
      const value = this.aceEditor?.getValue() ?? '';
      this.Model = value;
      this.ModelChange.emit(value);
    }, 1000);
  }

  mediaSelected(event: any) {
    if(event == null || !this.aceEditor) return;

    var cursorPosition = this.aceEditor.getCursorPosition();
    var type = event.split('.').at(-1);
    if(type == 'm4v') type = 'mp4'; // needed otherwise embed doesn't play
    if(['mp4', 'webm'].includes(type)) {
      this.aceEditor.session.insert(cursorPosition, '<video autoplay muted loop> <source src="{MediaService}/' + event + '" type="video/' + type +'" /> </video>')
    } else {
      this.aceEditor.session.insert(cursorPosition, '<img src="{MediaService}/' + event + '" />');
    }
  }
}
